<template>
  <div @click.stop.prevent="$emit('close')" class="modal-back">
    <div @click.stop class="modal-inner">
      <div
        class="close-btn"
        @click="$emit('close')"
        data-shortcut-esc="palettePopup"
      >
        <span></span>
      </div>
      <h4>テーマ保存</h4>
      <ul class="type-select">
        <li>
          <input
            id="select1"
            type="radio"
            value="new"
            v-model="model.saveType"
          >
          <label for="select1">新規保存</label>
          <div
            :class="{ 'disable': model.saveType !== 'new' }"
            class="select-margin"
          >
            <label><span>テーマ名</span>
              <input
                type="text"
                v-model="model.name"
                class="common-input"
                :class="{ 'error-border': validations['name'] }"
              >
              <span
                v-if="validations['name']"
                class="error-message"
              >
                {{ validations['name'] }}
              </span>
            </label>
          </div>
        </li>
        <li v-if="themes.length > 0">
          <input
            id="select2"
            type="radio"
            value="overwrite"
            v-model="model.saveType"
          >
          <label for="select2">上書き保存</label>
          <div>
            <div class="common-select theme-select">
              <select
                :class="{ 'disable': model.saveType !== 'overwrite' }"
                @input="selectTheme($event.target.value)">
                <option v-for="(theme, index) in themes" :key="index" :value="index">
                  {{ theme.name }}
                </option>
              </select>
            </div>
          </div>
        </li>
      </ul>
      <div class="button-box">
        <button @click="save" class="normal-btn ok">保存</button>
        <button @click="$emit('close')" class="normal-btn cancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  mixins: [
    ShortCutBase,
  ],
  props: [
    'themes',
  ],
  data () {
    return {
      model: {
        saveType: 'new',
        name: '',
      },
      validations: {},
      themeSelectOption: false,
      selectedTheme: {},
    }
  },
  mounted () {
    this.selectedTheme = this.themes[0]
  },
  methods: {
    themeSelectHidden () {
      this.themeSelectOption = false
    },
    selectTheme (theme) {
      this.selectedTheme = this.themes[Number(theme)]
      this.themeSelectHidden()
    },
    save () {
      const formData = new FormData()
      if (this.model.saveType === 'new') {
        // 新規保存
        formData.append('name', this.$utils.string.b64Encode(this.model.name))
      } else if (this.model.saveType === 'overwrite') {
        // 上書き保存
        formData.append('id', this.selectedTheme.id)
      } else {
        return
      }
      const theme = {}
      theme.contentStyles = this.$store.getters.findContentStyles
      theme.contentMobileStyles = this.$store.getters.findMobileStyles
      theme.sectionStyles = {}
      this.$store.getters.getSectionAll.forEach(section => {
        theme.sectionStyles[section.name] = section.styles
      })
      formData.append('theme', JSON.stringify(theme))
      formData.append('formValidationKeys[]', 'name')
      this.$http({
        url: '/theme/save',
        type: 'POST',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          this.model = {
            saveType: 'new',
            name: '',
          }
          this.selectedTheme = {}
          this.$emit('saved')
        } else {
          this.validations = json.validations ? json.validations : {}
        }
      })
    },
    onThemeSelectOption (event) {
      const classList = event.target.classList
      if (!classList.contains('choice-theme-item') && !classList.contains('current-theme') && !classList.contains('choice-theme')) {
        // イベントが選択、リスト表示ボタンによるもの以外だったら閉じる
        this.themeSelectHidden()
        document.removeEventListener('mousedown', this.onThemeSelectOption)
      }
    },
  },
  watch: {
    themeSelectOption (value) {
      if (value) {
        // click.stopにより、v-on-clickawayが効かないため個別に対応
        document.addEventListener('mousedown', this.onThemeSelectOption)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.modal-inner {
  color: $commonFontColor;
  width: 400px;
  background:#F8F8F8;
  border-radius: 2px;
  padding: 10px 20px 20px;
  box-shadow: 0 3px 4px rgba(32, 32, 32, 0.3);
  position: relative;
  .close-btn {
    position: absolute;
    display: inline-block;
    width: 35px;
    height: 35px;
    top: 5px;
    right: 5px;
    border: none;
    cursor: pointer;
    background: none;
    outline: none;
    span::before, span::after {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 2px;
      border-radius: 2px;
      margin: -1px 0 0 -13px;
      background: #555;
    }
    span::before {
      transform: rotate(-45deg);
    }
    span::after {
      transform: rotate(45deg);
    }
    &:hover {
      opacity: 0.7;
    }
  }
  h4 {
    border-bottom: 1px solid #dbdbdb;
    line-height: 2;
  }
  .type-select {
    margin-bottom: 30px;
    li {
      margin-top: 10px;
      > input {
        margin-right: 8px;
      }
    }
    .disable {
      pointer-events: none;
      opacity: 0.8;
      color: #ccc;
      input {
        color: #ccc;
      }
    }
    label span{
      display: block;
      font-size: 14px;
      margin: 10px 0 3px;
    }
    .common-input {
      width: 360px;
    }
    .theme-select {
      margin: 3px 20px 0 20px;
      width: calc(100% - 40px);
    }
    .select-margin {
      margin: 0 20px 0;
    }
  }
  .button-box {
    display: flex;
    justify-content: center;
    button {
      font-size: 14px;
      border: solid 1px #c6c6c6;
      border-radius: 5px;
      &:hover {
        opacity: 0.8;
      }
      &.ok {
        margin-right: 20px;
        color: #fff;
        border: solid 1px #484848;
        background: #484848;
      }
    }
  }
}
</style>
